// @flow

import * as React from 'react';
import classnames from '@ta/common.classnames';
import { Icon } from '@ta/styleguide.icon';
import styles from './SocialActionButton.less';

type Props = {|
  /** The icon name */
  icon: string,
  /** Additional class name styling to apply to the outermost HTML element */
  className?: string,
  /** If true, inverts the color scheme to be black on white. Defaults to false */
  invert?: boolean,
  /** A callback that is fired when the button is clicked */
  onClick?: (SyntheticEvent<*>) => mixed,
|};

/** Prompts users to take a social action */

const SocialActionButton = ({ icon, className, onClick, invert }: Props) => (
  <span
    className={classnames(styles.action_button, className, { [styles.invert]: invert })}
    onClick={onClick}
  >
    <Icon name={icon} />
  </span>
);

SocialActionButton.defaultProps = {
  className: undefined,
  onClick: undefined,
  invert: false,
};

export default SocialActionButton;
